import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export const ImportResult = ({ result }) => (
  <section className="border border-border bg-white p-5 space-y-4" data-testid="rfq-import-result">
    <div className="flex items-start gap-3">
      <CheckCircle2 size={22} className="text-[#3D6DF2] mt-0.5" />
      <div>
        <h2 className="text-lg font-semibold" data-testid="rfq-import-result-title">Importazione completata · {result.counts.created} richieste create{result.counts.skipped ? ` · ${result.counts.skipped} righe saltate` : ""}</h2>
        <p className="text-sm text-muted-foreground">{result.lot_reference ? `Lotto ${result.lot_reference} · ` : ""}{result.file_name}. Nessuna lettura AI avviata: per ogni pezzo carica il disegno PDF dalla sua richiesta, poi premi «Avvia lettura».</p>
      </div>
    </div>
    <table className="dense-table w-full">
      <thead><tr><th>Riferimento</th><th>Descrizione</th><th className="text-right">Q.tà</th><th>Prossimo passo</th></tr></thead>
      <tbody>
        {result.created.map(c => <tr key={c.rfq_id} data-testid={`rfq-import-created-${c.row_number}`}>
          <td className="font-mono"><Link className="underline link-tech font-semibold" to={`/rfqs/${c.rfq_id}`} data-testid={`rfq-import-open-${c.row_number}`}>{c.reference}</Link></td>
          <td className="max-w-md truncate">{c.description || "—"}</td>
          <td className="text-right font-mono">{c.quantity ?? "—"}</td>
          <td><Link className="text-xs underline" to={`/rfqs/${c.rfq_id}`} data-testid={`rfq-import-upload-${c.row_number}`}>Carica PDF →</Link></td>
        </tr>)}
      </tbody>
    </table>
    {result.skipped.length > 0 && <details data-testid="rfq-import-skipped"><summary className="text-sm cursor-pointer">Righe saltate · {result.skipped.length}</summary>
      <ul className="text-xs mt-2 space-y-1">{result.skipped.map(s => <li key={s.row_number}>Riga {s.row_number}: {s.why}{s.rfq_id && <> → <Link className="underline" to={`/rfqs/${s.rfq_id}`}>{s.reference}</Link></>}</li>)}</ul>
    </details>}
    <div className="flex flex-wrap gap-4 text-sm">
      <Link className="underline" to="/rfqs" data-testid="rfq-import-go-list">Vai alle richieste →</Link>
      <Link className="underline" to="/rfqs/import" onClick={() => window.location.reload()} data-testid="rfq-import-again">Importa un altro file</Link>
    </div>
  </section>
);
